export const ADD_PAYMENT_MODAL = 'ADD_PAYMENT_MODAL';
export const MODIFY_PAYMENT_MODAL = 'MODIFY_PAYMENT_MODAL';
export const GET_PAY_REQ_DET  = 'GET_PAY_REQ_DET';
export const GET_PAY_REQ_DET_SUCCESS = 'GET_PAY_REQ_DET_SUCCESS';
export const GET_PAY_REQ_DET_FAILURE  = 'GET_PAY_REQ_DET_FAILURE';
export const GET_HISTORICAL_PAYREQ_DET  = 'GET_HISTORICAL_PAYREQ_DET';
export const GET_HISTORICAL_PAYREQ_DET_SUCCESS = 'GET_HISTORICAL_PAYREQ_DET_SUCCESS';
export const GET_HISTORICAL_PAYREQ_DET_FAILURE  = 'GET_HISTORICAL_PAYREQ_DET_FAILURE';
export const GET_ACCOUNT_DET = 'GET_ACCOUNT_DET';
export const GET_ACCOUNT_DET_SUCCESS = 'GET_ACCOUNT_DET_SUCCESS';
export const GET_ACCOUNT_DET_FAILURE = 'GET_ACCOUNT_DET_FAILURE';
export const UPDATE_PAY_REQ_DET = 'UPDATE_PAY_REQ_DET';
export const RESET_STATE = 'RESET_STATE';
export const UPDATE_PAY_SSI_DEP ='UPDATE_PAY_SSI_DEP';
export const GET_STK_DET= 'GET_STK_DET';
export const GET_STK_DET_SUCCESS= 'GET_STK_DET_SUCCESS';
export const GET_STK_DET_FAILURE= 'GET_STK_DET_FAILURE';
export const GET_HOLIDAY_LIST = 'GET_HOLIDAY_LIST';
export const GET_HOLIDAY_LIST_SUCCESS = 'GET_HOLIDAY_LIST_SUCCESS';
export const GET_HOLIDAY_LIST_FAILURE = 'GET_HOLIDAY_LIST_FAILURE';
export const UPDATE_HOLIDAY_LIST ='UPDATE_HOLIDAY_LIST';
export const ADD_PMR_HOLIDAY='ADD_PMR_HOLIDAY';
export const DELETE_PMR_HOLIDAY='DELETE_PMR_HOLIDAY';
export const EXPORT_PAYMENT_REPORT ='EXPORT_PAYMENT_REPORT';
